'use client';

import { AlertTriangle, Flag } from 'lucide-react';
import { useEffect, useState } from 'react';

export default function ModerationFAB({ toneId }: { toneId: number }) {
  const [isFlagged, setIsFlagged] = useState(false);

  useEffect(() => {
    // Fetch via the moderation API (service-role) so private tones are
    // readable too — client-side RLS would hide rows the moderator doesn't own.
    const fetchTone = async () => {
      try {
        const response = await fetch(`/api/tones/moderation/get?tone_id=${toneId}`);
        if (!response.ok) return;
        const { tones } = await response.json();
        setIsFlagged(tones?.[0]?.is_flagged || false);
      } catch (error) {
        console.error(error);
      }
    };
    fetchTone();
  }, [toneId]);

  const handleClick = () => {
    // Open admin/tones page in new tab with tone_id as search param
    const url = `/admin/tones?tone_id=${toneId}`;
    window.open(url, '_blank');
  };

  return (
    <div className="fixed bottom-6 right-6">
      <button
        onClick={handleClick}
        className="flex h-10 w-10 items-center justify-center rounded-full bg-red-500 text-white shadow-lg hover:bg-red-600 transition-colors duration-200 relative"
      >
        <AlertTriangle className="h-5 w-5" />
        {isFlagged && (
          <div className="absolute top-[-7px] right-[-7px] bg-yellow-400 text-white text-xs px-1 py-1 rounded-full">
            <Flag className="h-4 w-4" />
          </div>
        )}
      </button>
    </div>
  );
}
